jQuery(function($) {
  var loadGallery = function() {
    $('.gallery__grid').removeClass('gallery__grid--hidden');
  }

  $('.js-view-more').on('click', function(e) {
    e.preventDefault();
    loadGallery();
    $('.js-view-more').hide();

  });
});